import { useEffect } from 'react';
import { useLocation } from 'react-router';
import ReactGA from 'react-ga4';

// Universal Analytics was shut down in 2023, so this now expects a GA4
// measurement ID (G-XXXXXXXXXX). With no GA_ID configured, analytics is a no-op.
const enabled = NODE_ENV === 'production' && Boolean(GA_ID);

if (enabled) {
  ReactGA.initialize(GA_ID);
}

const Analytics = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (enabled) {
      ReactGA.send({ hitType: 'pageview', page: pathname });
    }
  }, [pathname]);

  return null;
};

export default Analytics;
